import React, {FC} from 'react';
import LogoUI from "@/components/LogoUI";
import { useNavigate } from 'react-router';

/**
 * 作者: nick
 * 时间: 2023/5/26
 * 说明: ***
 * index
 * index.tsx
 * src/layout/components/MobileMenuHeader
 */

interface IProps {
    title:string
}

const MobileMenuHeader:FC<IProps> = () => {
    const navigate = useNavigate();

    return (
        <div className={'mobile-logo'} onClick={() => navigate('/home')}>
            <LogoUI showBig={true}/>
        </div>
    )
};

export default MobileMenuHeader;
